import { extendObservable, observable } from 'mobx';
export function TreeNode(value, children) {
  return extendObservable({}, {
    value: value,
    children: observable.array(children)
  });
} // Asynchronous DFS from root node for a matching path based on return of visitor function.

export function findPath(match, node) {
  var matched = match(node);

  if (matched) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        var childPath = findPath(match, child);

        if (childPath.length > 0) {
          childPath.unshift(node);
          return childPath;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return [node];
  }

  return [];
} // DFS for finding a matching node by predicate.

export function findNode(predicate, node) {
  if (predicate(node)) return node;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = node.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var child = _step2.value;

      var _node = findNode(predicate, child);

      if (_node) return _node;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return null;
}